/**
 * @description: 将具有节点和父节点的数组，转换为树状节点
 * @param {Array} dataSource 数组数据，带有节点和父节点
 * @return: 树状数组
 */
export function toTreeData(dataSource, { id, idField, nameField, parentIDField, parentNameField, root = '', navId = '', codeField = '' }, keyword) {
  // 未定义返回空数组
  if (typeof dataSource === 'undefined') {
    return []
  }
  // 复制数据
  let source = JSON.parse(JSON.stringify(dataSource))
  // 过滤查找所有根节点，返回数组
  function findLevelRoot(records) {
    const { length } = records
    const rootRecords = []
    for (let i = 0; i < length; i += 1) {
      const record = records[i]
      // 查看当前节点是否存在父节点，不存在，则是根节点数组
      const parentId = record[parentIDField]
      const hasParent = records.find((item) => item[idField] === parentId)
      // 无父，无子 push, 无父、有子 push
      if (!hasParent) {
        // 给根节点 parentNameField 初始值;
        record[parentNameField] = root
        // 添加到根节点数组
        rootRecords.push(record)
      }
    }
    return rootRecords
  }

  // 递归查找子节点
  // parentId = id
  function findChindren(records, parentId, parentName) {
    const tree = []
    let temp
    const { length } = records
    for (let i = 0; i < length; i += 1) {
      const record = records[i]
      if (record[parentIDField] === parentId) {
        if(record.resId){
          temp = findChindren(records, record[id], record[nameField])
        } else {
          temp = findChindren(records, record[idField], record[nameField])
        }
        if (temp.length > 0) {
          record.children = temp
        }
        record[parentNameField] = parentName
        tree.push({ ...record })
      }
    }
    return tree
  }

  // 给根节点添加子节点
  function AddChildren() {
    if (navId === '') {
      // 获取根节点数组
      const rootRecords = findLevelRoot(source)
      const { length } = rootRecords
      // 循环根节点数组
      for (let i = 0; i < length; i += 1) {
        const record = rootRecords[i]
        // 逐个查找此根节点下子节点
        const children = findChindren(source, record[idField], record[nameField])
        if (children.length) {
          // 找到了，则将子几点挂在到children属性上
          record.children = children
        }
      }
      return rootRecords
    }
    const children = findChindren(source, navId, '')
    return children
  }

  // 查找某个节点的所有父节点包括上上级,不嵌套
  function findParentData(id) {
    let newArr = []
    let temp
    const { length } = source
    for (let i = 0; i < length; i += 1) {
      const record = source[i]
      if (record[idField] === id) {
        temp = findParentData(record[parentIDField])
        newArr = [record, ...temp]
        break
      }
    }
    return newArr
  }
  // 获取某个节点下所有子节点
  function findChindrenData(records, parentId) {
    let newArr = []
    let temp
    const { length } = records
    for (let i = 0; i < length; i += 1) {
      const record = records[i]
      if (record[parentIDField] === parentId) {
        temp = findChindrenData(records, record[idField])
        newArr = [record, ...newArr, ...temp]
        // newArr = [record, ...temp];
        // break;
      }
    }
    return newArr
  }

  // 搜索过滤关键字体
  function filterSource(word) {
    // 查找到包括关键字的数组
    const wordRecords = source.filter(
      (item) => item[nameField].toUpperCase().indexOf(word.toUpperCase()) > -1 || (item[codeField] && item[codeField].toUpperCase().indexOf(word.toUpperCase()) > -1),
    )
    let newArr = []
    const { length } = wordRecords
    // 循环关键字数组
    for (let i = 0; i < length; i += 1) {
      const record = wordRecords[i]
      // 逐个查找节点所有父节点
      const parents = findParentData(record[parentIDField])

      // 逐个查找此根节点下子节点
      const children = findChindrenData(source, record[idField])
      // 将自己，父节点、子节点合并到新数组
      newArr = [record, ...newArr, ...parents, ...children]
    }
    // 去除重复对象
    const sets = new Set()
    newArr.forEach((item) => {
      sets.add(item)
    })
    // 转换为数组
    return Array.from(sets)
  }
  // 如果有搜索关键字，则过滤数据
  if (keyword) {
    source = filterSource(keyword)
  }
  return AddChildren()
}

export function getTopData(dataSource, { idField, parentIDField, parentNameField, root = '' }) {
  // 未定义返回空数组
  if (typeof dataSource === 'undefined') {
    return []
  }
  // 复制数据
  const source = JSON.parse(JSON.stringify(dataSource))
  // 过滤查找所有根节点，返回数组
  function findLevelRoot(records) {
    const { length } = records
    const rootRecords = []
    for (let i = 0; i < length; i += 1) {
      const record = records[i]
      // 查看当前节点是否存在父节点，不存在，则是根节点数组
      const parentId = record[parentIDField]
      const hasParent = records.find((item) => item[idField] === parentId)
      // 无父，无子 push, 无父、有子 push
      if (!hasParent) {
        // 给根节点 parentNameField 初始值;
        record[parentNameField] = root
        // 添加到根节点数组
        rootRecords.push(record)
      }
    }
    return rootRecords
  }

  return findLevelRoot(source)
}

export default {}
